/* eslint no-unused-vars: 0  */
/* global $ */

/*
  Any custom project animations
*/

import { hasIOSupport } from '../helpers/feature-detects';

function animatePhone(phone, startingDelay = 0) {
  const $phone = $(phone);
  const $outerPhone = $phone.closest('.animated-phone');
  const $wave = $phone.find('.wave-container');
  const phoneTimeouts = [];

  const messages = $(
    $phone
      .addClass('playing')
      .find('.user-msg')
      .not('.wave-container,.active,.animating')
      .get()
      .reverse(),
  ).each((index, el) => {
    const $el = $(el);
    const userClasses = $(el).attr('class');

    if (index === 0) {
      $el.addClass('animating');
    }

    phoneTimeouts.push(
      setTimeout(() => {
        $phone.addClass('animating');
        $outerPhone.addClass('typing');
        $phone.prepend(
          $wave.attr('class', `wave-container active ${userClasses}`),
        );
      }, startingDelay),
    );

    phoneTimeouts.push(
      setTimeout(() => {
        $wave.removeClass('active');
      }, startingDelay + 1200),
    );

    phoneTimeouts.push(
      setTimeout(() => {
        $outerPhone.removeClass('typing');
        $el.addClass('active').removeClass('animating');
        $el.prev().addClass('animating');
      }, startingDelay + 1400),
    );

    startingDelay += 4000;
  });

  if (!messages.length) {
    $outerPhone.addClass('done');
  }
  // console.log('timeouts', phoneTimeouts);
  $phone.data('timeouts', phoneTimeouts);
}

function pausePhone(phone) {
  // console.log('pausing', phone);
  const $phone = $(phone)
    .removeClass('unplayed playing typing')
    .addClass('paused');
  const $phoneInner = $phone.find('.animated-phone__dialog');

  setTimeout(() => $phone.removeClass('just-clicked'), 300);

  const savedTimeouts = $phoneInner.data('timeouts');
  const $wave = $phoneInner.find('.wave-container');
  $wave.removeClass('active animating');
  $phoneInner
    .find('.user-msg.animating')
    .removeClass('animating')
    .addClass('active');
  if (Array.isArray(savedTimeouts)) {
    savedTimeouts.forEach((timeout) => clearTimeout(timeout));
  }
}

$(document).ready(() => {
  const mmReduceAnimations = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  );
  const runAnimations = mmReduceAnimations && !mmReduceAnimations.matches;

  if (runAnimations) {
    // $.$body.find('.animated-phone__dialog').each((i, phone) => {
    //   animatePhone(phone, 300); // should be replaced by intersection observer..
    // });
    // console.log('running animations');

    const config = {
      root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
      rootMargin: '0px',
      threshold: 0.5,
    };
    let isLeaving = false;

    const phones = document.querySelectorAll('.animated-phone');

    if (hasIOSupport) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // console.log(entry.isIntersecting);
          if (entry.isIntersecting) {
            isLeaving = true;
            const $phone = $(entry.target);
            if ($phone.hasClass('unplayed') || !$phone.hasClass('playing')) {
              const $dialog = $phone.find('.animated-phone__dialog');
              // console.log('playing for reals', $phone);
              $phone.removeClass('unplayed');
              animatePhone($dialog.get(0));
            }
          } else if (isLeaving) {
            isLeaving = false;
            pausePhone(entry.target);
          }
        });
      }, config);

      // console.log(phones);
      phones.forEach((phone) => {
        // console.log(phone);
        observer.observe(phone);
      });
    } else {
      // just play all phones
      phones.forEach((phone) => {
        animatePhone(
          $(phone)
            .removeClass('unplayed')
            .find('.animated-phone__dialog')
            .get(0),
        );
      });
    }

    $.$body.on('click', '.animated-phone', (e) => {
      pausePhone(e.currentTarget);
      const $phoneInner = $(e.currentTarget)
        .addClass('just-clicked')
        .find('.animated-phone__dialog');
      animatePhone($phoneInner, 300);
    });
  } else {
    console.log('setting all phones to played state');
    $.$body.find('.animated-phone').removeClass('unplayed');
    $.$body.find('.user-msg').addClass('active');
    $.$body.find('.wave-container').hide();
    setTimeout(() => {
      $.$body.find('.animated-phone__dialog').scrollTop(0);
    }, 10);
  }
});
